import React, { Component } from 'react';
import Header from '../header';
import Footer from '../footer';
import './index.less';
import Logo from './img/logo.png'
import Title from './img/title.png'
import Enter from './img/enter.png'

/**
 * 首页
 */
class Home extends Component {
    render() {
        return (
            <div className="home">
                {/* <Header /> */}
                <div className="home__wrapper">
                    <img src={Logo} className="home__pic1" />
                    <img src={Title} className="home__pic2" />
                    <a href="/pages/cqsx/jobs"><img src={Enter} className="home__pic3" /></a>
                </div>
                {/* <Footer /> */}
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./_source/cqsx/pages/cqsx/cmps/home/index.js